import { render, staticRenderFns } from "./ManualCC.vue?vue&type=template&id=5871d4d2"
import script from "./ManualCC.vue?vue&type=script&lang=js"
export * from "./ManualCC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports